import React from 'react'
import './modal-rating.css'

const ModalRating = ({ rating }) => (
  <div className='modal-rating'>
    <input type='radio' name='rating' value='5' defaultChecked={rating === 5 || rating === 4.5} />
    <label className='full' />
    <input type='radio' name='rating' value='4' defaultChecked={rating === 4 || rating === 3.5} />
    <label className='full' />
    <input type='radio' name='rating' value='3' defaultChecked={rating === 3 || rating === 2.5} />
    <label className='full' />
    <input type='radio' name='rating' value='2' defaultChecked={rating === 2 || rating === 1.5} />
    <label className='full' />
    <input type='radio' name='rating' value='1' defaultChecked={rating === 1 || rating === 0.5} />
    <label className='full' />
  </div>
)

export default ModalRating



// WEBPACK FOOTER //
// ./src/components/Modal/ModalItem/components/ModalRating/index.js